// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import { Multiselect } from 'react-widgets';

class EditHostedGame extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      selected_one: {
        venue: '',
        game_type: '',
        date: '',
        start_time: '00:00',
        game_level_id: 1,
        end_time: '00:00',
        price: 0,
        batch_size: 0,
      },
      venues: [],
      game_types: [],
      game_levels: [],
      data_uploaded: false,
      data_error: false,
      selected_buddies: [],
      buddies: [],
      temp_buddies: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.onStartTimeChange = this.onStartTimeChange.bind(this);
    this.onEndTimeChange = this.onEndTimeChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    

    const datePicker=document.getElementsByClassName("datePicker")[0];
    datePicker.childNodes[0].setAttribute("readOnly",true);
    
  }

  getFixtureList() {

     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_levels: data.game_levels,game_types: data.game_type},()=>{this.getFixtureData();}))
       .catch(error => error);
  }

  getAllBuddies(buddies){
    const url = `${getLocationOrigin()}/cm/get_buddies/?venue=${this.state.selected_one.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        var sel_buddies = data.buddies.filter(buddy => buddies.includes(buddy.id))
        this.setState({buddies:data.buddies,selected_buddies:sel_buddies});
    }).catch(error => error);
    }

  getFixtureData() {
    console.log('id',this.state.id)
    const url = `${getLocationOrigin()}/eagleeye/get_hosted_game/?fixture_id=${this.state.id}`;
    const options = {...defaultOptions};

   fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => this.setState({},()=>{this.setData(data.result);}))
     .catch(error => error);
  }

  postCreateGame(data, buddies, props) {
    const url = `${getLocationOrigin()}/eagleeye/update_hosted_game/`;
    const options = {...defaultOptions};
    var venue = data.venue
    var game_type = data.game_type
    var game_level_id = data.game_level_id
    var bud_ids = []
    for( var i in buddies)
    {
      bud_ids.push(buddies[i].id)
    }
    if(!data.venue){venue=this.state.venues[0].id}
    if(!data.game_type){game_type=this.state.game_types[0].pk}
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'fixture_id': this.state.id,
                        'game_type_id': game_type,
                        'game_level_id': game_level_id,
                        'price': data.price,
                        'batch_size': data.batch_size,
                        'buddies': bud_ids
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  setData(data){
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one['date'] = data.date
    new_selected_one['start_time'] = data.start_time.substring(0,5)
    new_selected_one['end_time'] = data.end_time.substring(0,5)
    new_selected_one['price'] = data.price
    new_selected_one['venue'] = data.venue
    new_selected_one['batch_size'] = data.batch_size
    new_selected_one['game_type'] = data.game_type
    new_selected_one['game_level_id'] = data.game_level

    var venue = this.state.venues.find(ven => ven.id == data.venue)
    this.setState({selected_one:new_selected_one,game_types:venue.game_types,game_levels:venue.game_levels},()=>{this.getAllBuddies(data.buddies);})
  }

  handleDate(date){
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one['date'] = date
    this.setState({selected_one: new_selected_one});
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one[name] = event.target.value
    this.setState({selected_one: new_selected_one});
  }

  onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['start_time'] = options
    this.setState({selected_one: new_value});
  }

  onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['end_time'] = options
    this.setState({selected_one: new_value});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateGame(this.state.selected_one, this.state.selected_buddies, this.props);
    console.log('post');
    console.log(this.state);
  }

  onSelect(optionsList, selectedItem) {
    this.state.temp_buddies.push(optionsList)
    this.setState({ selected_buddies: this.state.temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  render() {
    console.log(this.state.selected_one);
    console.log('success');
    console.log(this.state);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            Host a Game
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6 date_picker">
                Date
              </div>
              <input style={styles.input} value={this.state.selected_one.date} disabled='disabled'/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.selected_one.venue}
                onChange={this.handleChange} disabled='disabled'>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6" value={this.state.selected_one.game_type} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Levels
              </div>
              <select name="game_level_id" style={styles.item_body} className="col-md-6" onChange={this.handleChange} value={this.state.selected_one.game_level_id}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>Start Time </span>
                    </div>
                    <div className='col-md-6' >
                        <input className="col-md-3" style={styles.input} value={this.state.selected_one.start_time} name='start_time' disabled='disabled' />
                    </div>
                </div>
                <div style={{width:'50%'}} className="col-md-6">
                    <div style={styles.item_header} className="col-md-6">
                        <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>End Time </span>
                    </div>
                    <div className='col-md-6' >
                        <input className="col-md-3" style={styles.input} value={this.state.selected_one.end_time} name='end_time' disabled='disabled'  />
                    </div>
                </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Size
              </div>
              <input type="number" style={styles.input} name="batch_size" className="required"
                value={this.state.selected_one.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="number" style={styles.input} name="price" className="required"
                value={this.state.selected_one.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddies
              </div>
              <div className="col-md-6">
                <Multiselect
                  id="1"  
                  placeholder="Buddies"
                  data={this.state.buddies}
                  value = {this.state.selected_buddies}
                  textField='buddy'
                  onSelect={this.onSelect} 
                  onChange={this.onChange}
                  filter='contains' 
                 />
              </div>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit"/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default EditHostedGame;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editHostedGame/index.js